import { Box } from "@mui/material";
import { H1 } from "../components/Typography";
import { FC } from "react";

const TopBanner: FC = () => {
  return (
    <Box
      sx={{
        borderRadius: 5,
        display: {
          md: "flex",
          xs: "none",
        },
        justifyContent: "space-between",
        alignItems: "center",
        backgroundColor: process.env.REACT_APP_PRIMARY_COLOR,
        background: process.env.REACT_APP_BUTTON_GRADIENT_COLOR,
        flexDirection: {
          xs: "column",
          sm: "column",
          md: "row",
        },
      }}
    >
      <Box
        component="img"
        sx={{
          height: {
            xs: "60%",
            sm: "60%",
            md: "30%",
          },
          width: {
            xs: "60%",
            sm: "60%",
            md: "20%",
          },
        }}
        src="https://acru-asset.s3.us-east-1.amazonaws.com/assets/mfBannerLeft.svg"
        alt="saas-dasboard-footer"
      />

      <Box
        justifyContent="center"
        textAlign="center"
        sx={{
          width: {
            xs: "80%",
            sm: "80%",
            md: "60%",
          },
          paddingY: {
            xs: 2,
            sm: 2,
            md: 3,
          },
          alignItems: "center",
          justifyContent: "center",
          display: "flex",
        }}
      >
        <H1
          fontSize={24}
          fontWeight={600}
          sx={{
            textAlign: "center",
            fontFamily: "'Poppins', sans-serif",
          }}
          color="#ffffff"
        >
          Invest for your future with mutual funds – the smart way to grow your
          wealth
        </H1>
      </Box>
      <Box
        component="img"
        sx={{
          height: {
            xs: "60%",
            sm: "60%",
            md: "20%",
          },
          width: {
            xs: "60%",
            sm: "60%",
            md: "15%",
          },
          display: {
            xs: "none",
            md: "block",
          },
        }}
        src="https://acru-asset.s3.us-east-1.amazonaws.com/assets/mfBannerRight.svg"
        alt="saas-dasboard-footer"
      />
    </Box>
  );
};

export default TopBanner;
